module.exports = __webpack_public_path__ + "img/電気回路_2_7_1.f3b99bef.png";